import React, {useEffect, useState} from 'react';
import CorporateRegionsModal from '../CorporateRegionsModal';
import Input from '../../Input';
import {
  useLazyGetAgencyQuery,
  useLazyRegionDetailsQuery,
} from '../../../store/builder/inspections.api';
import {useDispatch} from 'react-redux';
import {setLoader} from '../../../store/builder/reducer';
import CorporateRegionDetailsRow from '../CorporateRegionDetailsRow';
import {useDebounce} from '../../../pages/LogSheets/hooks';
import {useTranslation} from '../../../hooks/useTranslation';

const CorporateRegionDetails = ({
  chosenRegionId,
  setCurrentRegion,
  currentRegion,
  setCurrentTab,
}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [agenciesList, setAgenciesList] = useState([]);
  const [newRegionsModal, setNewRegionsModal] = useState(false);
  const [filteredAgenciesList, setFilteredAgenciesList] = useState([]);
  const debouncedSearchValue = useDebounce(search, 500);

  const [
    getDetails,
    {
      data: detailsData,
      isLoading: detailsIsLoading,
      isError: detailsIsError,
      error: detailsError,
      isSuccess: detailsIsSuccess,
    },
  ] = useLazyRegionDetailsQuery();

  const [
    getAgencyList,
    {
      data: agencyListData,
      isLoading: agencyListIsLoading,
      isError: agencyListIsError,
      error: agencyListError,
      isSuccess: agencyListIsSuccess,
    },
  ] = useLazyGetAgencyQuery();

  const getDetailsRegion = () => {
    getDetails(chosenRegionId);
  };

  useEffect(() => {
    if (detailsIsLoading) {
      dispatch(setLoader(true));
    }
    if (detailsIsSuccess) {
      dispatch(setLoader(false));
    }
    if (detailsData?.data?.agencies?.length > 0) {
      setAgenciesList(detailsData?.data?.agencies);
    }
  }, [detailsIsLoading, detailsIsSuccess, detailsData]);

  useEffect(() => {
    if (chosenRegionId) {
      getDetailsRegion();
    }
  }, [chosenRegionId]);

  useEffect(() => {
    const filter = agenciesList?.filter(el => {
      if (debouncedSearchValue === '') {
        return el;
      } else {
        return el?.title?.toLowerCase()?.includes(search.toLowerCase());
      }
    });
    setFilteredAgenciesList(filter);
  }, [debouncedSearchValue, agenciesList]);

  useEffect(() => {
    getAgencyList();
  }, []);

  return (
    <div className='regions'>
      {newRegionsModal && (
        <CorporateRegionsModal
          exit={() => {
            setNewRegionsModal(false);
            setCurrentRegion(null);
          }}
          agencies={agencyListData}
          currentRegion={detailsData?.data}
          setCurrentRegion={setCurrentRegion}
          getRegionsList={getDetailsRegion}
        />
      )}
      <div
        className='metrics__head-back regions'
        onClick={() => setCurrentTab(5)}
      >
        <img src='/assets/icons/chevron-left.svg' alt='back' />
        <span>{t('corporateRegionDetails.back')}</span>
      </div>
      <p className='profile__title'>{detailsData?.data?.name}</p>
      <div className='regions__header'>
        <Input
          type='text'
          placeholder={t('corporateRegionDetails.searchPlaceholder')}
          name='ordersSearch'
          id='ordersSearch'
          image={'/assets/icons/search.svg'}
          maxwidth={204}
          value={search}
          onChange={e => {
            setSearch(e.target.value);
          }}
        />
        <div
          className='regions__header-btn'
          onClick={() => {
            setNewRegionsModal(true);
          }}
        >
          <span>{t('corporateRegionDetails.editRegion')}</span>
        </div>
      </div>
      <div className='regions__table details'>
        <div className='regions__table-header'>
          <div className='regions__table-th'>{t('corporateRegionDetails.tableHeaders.fbosId')}</div>
          <div className='regions__table-th'>{t('corporateRegionDetails.tableHeaders.name')}</div>
          <div className='regions__table-th'>{t('corporateRegionDetails.tableHeaders.airportId')}</div>
          <div className='regions__table-th'>{t('corporateRegionDetails.tableHeaders.timezone')}</div>
          <div className='regions__table-th'>{t('corporateRegionDetails.tableHeaders.logo')}</div>
        </div>
        <div className='regions__table-body'>
          {filteredAgenciesList?.length > 0 ? (
            filteredAgenciesList?.map(item => (
              <CorporateRegionDetailsRow key={item?.id} agency={item} />
            ))
          ) : (
            <div className='facility__table-empty'>
              <img src='/assets/icons/facility-empty.svg' alt='empty' />
              <p>{t('corporateRegionDetails.messages.noRegions')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CorporateRegionDetails;
